module.exports = __webpack_public_path__ + "static/media/branch-coffee.532e281b.jpg";